import React from 'react';
import store from '../../../../store';
// Popup imports
import { OpenPopup } from '../../../../actions/popupActions';
import { PopupTypes, PopupStates } from '../../../Popup/Enums';
import settings from '../../../../../settings';
// Game(kit) imports
import gameKit from '../../../../../GameKit';

class BtnSave extends React.Component {
    constructor(props) {
        super(props);

        this.id = 'le-btn-save';
        this.state = {
            disabled: false
        };
    }

    toggleActive = () => {
        const el = document.getElementById(`${this.id}`);
        el.toggleClass('active');

        const { disabled } = this.state;
        this.setState({ disabled: !disabled });
    };

    onSaveSuccess = () => {
        store.dispatch(OpenPopup(PopupTypes.SAVE, PopupStates.SUCCESS, {}));
        this.toggleActive();
    };

    onSaveError = resp => {
        store.dispatch(OpenPopup(PopupTypes.SAVE, PopupStates.ERROR, { response: resp }));
        this.toggleActive();
    };

    handleClick = () => {
        // Save game
        this.toggleActive();
        gameKit.saveGame(this.onSaveSuccess, this.onSaveError);
    };

    render = () => {
        const { disabled } = this.state;
        const { className } = this.props;

        return (
            <div id={`${this.id}`} className={`${className}`} type="button" onClick={this.handleClick} disabled={disabled}>
                <img draggable="false" alt="opslaan" src={`${settings.assetsPath}img/icons/disc.png`} />
            </div>
        );
    };
}

export default BtnSave;
